import { useAuthContext } from "@/context/auth";
import { hasPermissionInCompany, isForeignCompany } from "@/lib/support-access";

export const useHasPermission = (permission: string) => {
  const { user, companyContext } = useAuthContext();

  if (!user || !user.authorities) {
    return false;
  }
  const foreign = isForeignCompany(companyContext.currentCompany?.id, user.companyId);
  return hasPermissionInCompany(user.authorities, permission, foreign);
};
